import React from 'react';

const LoadingSpinner: React.FC = () => {
    return (
        <div className="flex justify-center items-center h-screen">
            <div className="w-32 h-32 border-8 border-gray-200 border-t-8 border-t-blue-500 rounded-full animate-spin"></div>
        </div>
    );
};

export default LoadingSpinner;
